import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _createForOfIteratorHelper from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { serchSelect, tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { newRechargeProductDailySummaryCurrency, newRechargeProductDailySummary } from "@/api/dataAll/userSegmentationGrowth";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
import * as XLSX from 'xlsx';
export default {
  name: "newUserPaid",
  mixins: [serchSelect, tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      tableData: [],
      deviceList: [{
        label: this.$t('newAccountLabel'),
        id: "user"
      }],
      paramsData: {
        dimension_kind: "user",
        penetration: 3
      },
      tableList: [],
      serverList: [],
      levelList: [],
      exportdataDealoading: false,
      validDates: [],
      // 有数据的日期（至少一个层级user_count>0）
      validLevels: [],
      // 有数据的层级（至少一个有效日期user_count>0）
      allProductIds: [],
      // 所有商品ID（全局）
      productIdMap: {},
      // 存储后端返回的商品名称映射
      dateValidProducts: {} // 按日期存储有效商品列（key: 日期, value: 该日期下非0商品ID数组）

    };
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  created: function created() {
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  methods: {
    levelChange: function levelChange(e) {
      if (!e) {
        this.paramsData.recharge_levels = '';
      }
    },
    getServer: function getServer() {
      var _this = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this.serverList = res.data;
        }
      });
    },
    searchClick: function searchClick() {
      var _this2 = this;

      // 重置所有数据
      this.tableList = [];
      this.tableData = [];
      this.validDates = [];
      this.validLevels = [];
      this.allProductIds = [];
      this.productIdMap = {};
      this.dateValidProducts = []; // 重置按日期存储的有效商品列

      if (this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      } // 基础校验


      if (!this.paramsData.dimension_kind) {
        this.$message.error(this.$t('pleaseSelectNewDeviceOrAccount'));
        return;
      }

      if (this.levelItem == '1' && !this.paramsData.recharge_levels) {
        this.$message.error(this.$t('pleaseInputLevel'));
        return;
      }

      if (/\uff0c/.test(this.paramsData.recharge_levels)) {
        // 匹配中文逗号
        this.$message.error(this.$t('pleaseInputEnglishComma'));
        return;
      }

      this.reqLoading = true;
      var params = {
        dimension_kind: this.paramsData.dimension_kind,
        game_id: this.searchData.game_id,
        special_product_id: this.searchData.special_product_id,
        starttime: this.searchData.starttime,
        endtime: this.searchData.endtime,
        server_id: this.paramsData.server_id,
        recharge_levels: this.paramsData.recharge_levels,
        penetration: this.paramsData.penetration,
        ad_channel: this.searchData.ad_channel,
        ad_placement: this.searchData.ad_placement
      }; // 判断是否有货币

      var searchCurrency = this.$store.state.d2admin.serchSelect.searchCurrency;
      var reqFn = searchCurrency.length ? newRechargeProductDailySummaryCurrency : newRechargeProductDailySummary;
      reqFn(params).then(function (res) {
        if (res.code == 200 && res.data) {
          var data = res.data;
          var tier_config = res.tier_config || {};
          _this2.productIdMap = res.product_id_map || {}; // 接收商品映射
          // 1. 筛选有数据的日期（至少一个层级user_count>0）

          _this2.filterValidDates(data); // 2. 筛选有数据的层级（至少一个有效日期user_count>0）


          _this2.filterValidLevels(data, tier_config); // 3. 获取所有商品ID（全局）


          _this2.getAllProductIds(data); // 4. 初始化tableData - 只保留有数据的层级


          _this2.tableData = _this2.validLevels.map(function (level) {
            var _tier_config$level, _tier_config$level2;

            return {
              level: level,
              recharge_range: ((_tier_config$level = tier_config[level]) === null || _tier_config$level === void 0 ? void 0 : _tier_config$level.range) || '',
              label: ((_tier_config$level2 = tier_config[level]) === null || _tier_config$level2 === void 0 ? void 0 : _tier_config$level2.label) || ''
            };
          }); // 5. 填充表格数据

          _this2.fillTableData(data); // 6. 按日期过滤全0商品列（核心：每个日期单独判断）


          _this2.filterZeroProductColumnsByDate(data); // 7. 构建最终的tableList（按日期展示有效商品列）


          _this2.buildTableList();
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },

    /**
     * 筛选有数据的日期
     * 规则：该日期下至少一个层级的user_count > 0
     */
    filterValidDates: function filterValidDates(data) {
      this.validDates = [];

      for (var date in data) {
        var hasValidData = false;

        for (var level in data[date]) {
          var _data$date$level;

          if (((_data$date$level = data[date][level]) === null || _data$date$level === void 0 ? void 0 : _data$date$level.user_count) > 0) {
            hasValidData = true;
            break;
          }
        }

        if (hasValidData) {
          this.validDates.push(date);
        }
      } // 按日期排序


      this.validDates.sort(function (a, b) {
        return new Date(a) - new Date(b);
      });
    },

    /**
     * 筛选有数据的层级
     * 规则：该层级在至少一个有效日期内user_count > 0
     */
    filterValidLevels: function filterValidLevels(data, tier_config) {
      this.validLevels = [];
      var levelSet = new Set();
      this.validDates.forEach(function (date) {
        for (var level in data[date]) {
          var _data$date$level2;

          if (((_data$date$level2 = data[date][level]) === null || _data$date$level2 === void 0 ? void 0 : _data$date$level2.user_count) > 0 && tier_config[level]) {
            levelSet.add(level);
          }
        }
      }); // 转换为数组并按层级排序

      this.validLevels = Array.from(levelSet).sort(function (a, b) {
        var numA = parseInt(a.replace('level_', '')) || 0;
        var numB = parseInt(b.replace('level_', '')) || 0;
        return numA - numB;
      });
    },

    /**
     * 获取所有商品ID（全局，不做筛选）
     */
    getAllProductIds: function getAllProductIds(data) {
      var _this3 = this;

      this.allProductIds = [];
      var productSet = new Set();
      this.validDates.forEach(function (date) {
        var _iterator = _createForOfIteratorHelper(_this3.validLevels),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _data$date, _data$date$level3;

            var level = _step.value;
            var productObj = ((_data$date = data[date]) === null || _data$date === void 0 ? void 0 : (_data$date$level3 = _data$date[level]) === null || _data$date$level3 === void 0 ? void 0 : _data$date$level3.product) || {}; // 兼容product是数组（空数据）和对象（有数据）的情况

            if (Object.prototype.toString.call(productObj) === '[object Object]') {
              for (var productId in productObj) {
                productSet.add(productId);
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }); // 转换为数组并排序

      this.allProductIds = Array.from(productSet).sort(function (a, b) {
        return a - b;
      });
    },

    /**
     * 填充表格数据
     */
    fillTableData: function fillTableData(data) {
      var _this4 = this;

      this.tableData.forEach(function (row) {
        var level = row.level;

        _this4.validDates.forEach(function (date) {
          var _data$date2, _data$date2$level, _data$date3, _data$date3$level;

          // 1. 填充付费人数数据
          var userCountProp = "".concat(date, "-user_count");
          row[userCountProp] = ((_data$date2 = data[date]) === null || _data$date2 === void 0 ? void 0 : (_data$date2$level = _data$date2[level]) === null || _data$date2$level === void 0 ? void 0 : _data$date2$level.user_count) || 0; // 2. 填充累积付费数据

          var totalAmountProp = "".concat(date, "-total_amount");
          row[totalAmountProp] = ((_data$date3 = data[date]) === null || _data$date3 === void 0 ? void 0 : (_data$date3$level = _data$date3[level]) === null || _data$date3$level === void 0 ? void 0 : _data$date3$level.total_amount) || 0; // 3. 填充所有商品数据

          _this4.allProductIds.forEach(function (productId) {
            var _data$date4, _data$date4$level;

            var productProp = "".concat(date, "-product-").concat(productId); // 兼容product是数组（空）和对象（有数据）

            var productObj = ((_data$date4 = data[date]) === null || _data$date4 === void 0 ? void 0 : (_data$date4$level = _data$date4[level]) === null || _data$date4$level === void 0 ? void 0 : _data$date4$level.product) || {};
            var productData = Object.prototype.toString.call(productObj) === '[object Object]' ? productObj[productId] || 0 : 0;
            row[productProp] = productData;
          });
        });
      });
    },

    /**
     * 按日期过滤全0商品列（核心：每个日期单独判断，互不影响）
     * 规则：某日期下该商品全0则隐藏，其他日期有数据则正常显示
     */
    filterZeroProductColumnsByDate: function filterZeroProductColumnsByDate(data) {
      var _this5 = this;

      this.validDates.forEach(function (date) {
        var validProducts = [];

        _this5.allProductIds.forEach(function (productId) {
          var hasNonZeroData = false; // 仅遍历当前日期下的所有层级，判断该商品是否有非0数据

          _this5.validLevels.forEach(function (level) {
            var _this5$tableData$find;

            if (hasNonZeroData) return;
            var productProp = "".concat(date, "-product-").concat(productId);
            var productValue = ((_this5$tableData$find = _this5.tableData.find(function (row) {
              return row.level === level;
            })) === null || _this5$tableData$find === void 0 ? void 0 : _this5$tableData$find[productProp]) || 0;

            if (Number(productValue) > 0) {
              hasNonZeroData = true;
            }
          }); // 当前日期下有非0数据，加入该日期的有效商品列


          if (hasNonZeroData) {
            validProducts.push(productId);
          }
        }); // 存储当前日期的有效商品列


        _this5.dateValidProducts[date] = validProducts;
      });
    },

    /**
     * 构建最终的tableList（按日期展示有效商品列，全0列不展示）
     */
    buildTableList: function buildTableList() {
      var _this6 = this;

      this.tableList = [{
        label: "",
        prop: "recharge_range",
        list: [{
          label: this.$t('payAmount'),
          prop: "recharge_range",
          level: "all"
        }]
      }]; // 遍历每个日期，单独构建列（仅展示该日期的有效商品列）

      this.validDates.forEach(function (date) {
        var dateItem = {
          label: date,
          prop: date,
          list: []
        }; // 1. 添加付费人数（始终保留）

        dateItem.list.push({
          label: _this6.$t('payPeopleCount'),
          prop: "".concat(date, "-user_count"),
          level: "all"
        }); // 2. 添加累积付费（始终保留）

        dateItem.list.push({
          label: _this6.$t('sumPayAmount'),
          prop: "".concat(date, "-total_amount"),
          level: "all"
        }); // 3. 添加当前日期的有效商品列（仅非0列，隐藏全0列）

        var currentValidProducts = _this6.dateValidProducts[date] || [];
        currentValidProducts.forEach(function (productId) {
          var productName = _this6.productIdMap[productId] || _this6.$t('unknownProduct');

          dateItem.list.push({
            label: productName,
            prop: "".concat(date, "-product-").concat(productId),
            level: "all"
          });
        }); // 添加到tableList

        if (dateItem.list.length > 0) {
          _this6.tableList.push(dateItem);
        }
      });
    },
    exportdata: function exportdata() {
      var _this7 = this;

      this.exportdataDealoading = true;

      try {
        // 1. 构建工作表数据
        var wsData = []; // 导出表头结构：行1=日期/付费金额，行2=付费人数/累积付费/商品名称

        var headerRow1 = [this.$t('payAmount')];
        var headerRow2 = [this.$t('amountRange')]; // 遍历tableList构建导出表头

        this.tableList.forEach(function (dateColumn) {
          if (dateColumn.prop === 'recharge_range') return;
          var dateLabel = dateColumn.label;
          var columnCount = dateColumn.list.length; // 行1：日期跨列

          headerRow1.push(dateLabel);

          for (var i = 1; i < columnCount; i++) {
            headerRow1.push('');
          } // 行2：填充当前日期的有效列标签


          dateColumn.list.forEach(function (subColumn) {
            headerRow2.push(subColumn.label);
          });
        }); // 添加表头行

        wsData.push(headerRow1);
        wsData.push(headerRow2); // 2. 构建数据行

        this.tableData.forEach(function (row) {
          var rowData = [row.recharge_range || ''];

          _this7.tableList.forEach(function (dateColumn) {
            if (dateColumn.prop === 'recharge_range') return;
            dateColumn.list.forEach(function (subColumn) {
              rowData.push(row[subColumn.prop] || 0);
            });
          });

          wsData.push(rowData);
        }); // 3. 创建工作表

        var ws = XLSX.utils.aoa_to_sheet(wsData); // 4. 设置合并单元格

        var merges = [];
        merges.push({
          s: {
            r: 0,
            c: 0
          },
          e: {
            r: 1,
            c: 0
          }
        });
        var colIndex = 1;
        this.tableList.forEach(function (dateColumn) {
          if (dateColumn.prop === 'recharge_range') return;
          var columnCount = dateColumn.list.length;

          if (columnCount > 1) {
            merges.push({
              s: {
                r: 0,
                c: colIndex
              },
              e: {
                r: 0,
                c: colIndex + columnCount - 1
              }
            });
          }

          colIndex += columnCount;
        });
        ws['!merges'] = merges; // 5. 设置列宽

        var colWidths = [];
        var maxRows = wsData.length;

        for (var col = 0; col < headerRow1.length; col++) {
          var _headerRow1$col, _headerRow2$col;

          var maxLength = 0;
          maxLength = Math.max(((_headerRow1$col = headerRow1[col]) === null || _headerRow1$col === void 0 ? void 0 : _headerRow1$col.toString().length) || 0, ((_headerRow2$col = headerRow2[col]) === null || _headerRow2$col === void 0 ? void 0 : _headerRow2$col.toString().length) || 0);

          for (var row = 2; row < maxRows; row++) {
            var cellValue = wsData[row][col];

            if (cellValue !== undefined && cellValue !== null) {
              maxLength = Math.max(maxLength, cellValue.toString().length);
            }
          }

          var width = Math.min(Math.max(maxLength + 4, 12), 30);
          colWidths.push({
            width: width
          });
        }

        ws['!cols'] = colWidths; // 6. 设置单元格样式

        var range = XLSX.utils.decode_range(ws['!ref'] || 'A1:A1'); // 表头样式

        for (var R = 0; R < 2; R++) {
          for (var C = range.s.c; C <= range.e.c; C++) {
            var cellAddress = XLSX.utils.encode_cell({
              r: R,
              c: C
            });
            if (!ws[cellAddress]) ws[cellAddress] = {
              t: 's',
              v: ''
            };
            ws[cellAddress].s = {
              font: {
                bold: true,
                sz: 10
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
                wrapText: true
              },
              fill: {
                fgColor: {
                  rgb: "E6E6FA"
                }
              }
            };
          }
        } // 数据行样式


        for (var _R = 2; _R <= range.e.r; _R++) {
          for (var _C = range.s.c; _C <= range.e.c; _C++) {
            var _cellAddress = XLSX.utils.encode_cell({
              r: _R,
              c: _C
            });

            if (ws[_cellAddress] && !ws[_cellAddress].s) {
              ws[_cellAddress].s = {
                alignment: {
                  horizontal: 'center',
                  vertical: 'center'
                }
              };
            }
          }
        } // 7. 导出文件


        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, this.$t('paymentPenetrationRateSheet'));
        var fileName = "".concat(this.$t('productPenetrationRate'), ".xlsx");
        XLSX.writeFile(wb, fileName);
        this.$message.success(this.$t('exportSuccess'));
      } catch (error) {
        console.error('导出失败:', error);
        this.$message.error(this.$t('exportFailedRetry'));
      } finally {
        this.exportdataDealoading = false;
      }
    }
  }
};